import { Navigate } from 'react-router-dom';
import { Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';

/**
 * Point d'entrée « / » : redirige vers le bon dashboard selon le rôle.
 * - Équipe interne (Bloomies : Admin / System) -> /missions-freelance (FreelanceMissionsDashboard)
 * - Freelance (Bloomer) -> /dashboard (son espace personnel)
 */
const DashboardRedirect = () => {
  const auth = useAuthStore((state) => state.auth);
  const roles = auth?.user?.roles || [];
  const isBloomies = roles.includes(Role.Admin) || roles.includes(Role.System);

  return <Navigate to={isBloomies ? '/missions-freelance' : '/dashboard'} replace />;
};

export default DashboardRedirect;
